module.exports = __webpack_public_path__ + "static/media/empty_state_claims_no_results.674dbef0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/empty_state_claims_no_results.svg
// module id = 939
// module chunks = 0